import { render, staticRenderFns } from "./DownloadPanel.vue?vue&type=template&id=87949d6c&"
import script from "./DownloadPanel.vue?vue&type=script&lang=js&"
export * from "./DownloadPanel.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPanel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports